<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style> 
.inputSubLabel{
  font-size: 14px;
  color: #bebebe;
  font-style: italic;
  line-height:20px
}
.heng{
  margin-top:10px;
  padding:5px;
  margin-left: 5%;
  height: 50px;
  border-radius: 5px;
  border: 1px dashed #65a8ff;
}
.Success{
  color: #67C23A;
}

.Warning {
  color: #E6A23C;
}

.Danger {
  color: #F56C6C;
}

.Info {
  color: #909399;
}

.cogold {
  color: #FFE063;
}
.co332 {
  color: #332F2F
}

.co81 {
  color: #818181;
}

.co80 {
  color: #808080;
}

.cob3 {
  color: #B3B3B3;
}

.coBlue {
  color: #22a1ff;
}

.coBlueDark {
  color: #317ef3;
}

.coOrange {
  color: #ffcd4c;
}

.co3 {
  color: #333333;
}

.coF {
  color: #FFFFFF;
}

.co37 {
  color: #37618C;
}

.co3e {
  color: #3E3E3E;
}

.coa9 {
  color: #A96F41;
}

.cored {
  color: #F73C37;
}

.co66 {
  color: #666666;
}

.co60 {
  color: #e60012;
}

.cofc {
  color: #fc766a;
}

.c2 {
  color: #c2c5cc;
}
.upload-list-cover {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 40px;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  opacity: 0;
  transition: opacity 1s;
}
.cover_icon {
  font-size: 30px;
}
.upload-btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px dashed #cccccc;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 1px #cccccc;
}
.upload-btn:hover {
  border: 1px dashed #69b7ed;
}
.upload-btn i {
  margin: 5px;
}
/* ::-webkit-scrollbar{
overflow: auto;
} */
.demo-drawer__footer{
  width: 50%;
  background-color: white;
  /* border-top-style: 1px solid #808080 !important; */
  /* border-top: 1px solid #8f8f8f; */
  height: 40px;
  position: fixed;
  box-shadow: 0 0 5px #a0a0a0;
  /* width: 100%; */
  bottom: 0;
  z-index:5 !important;
}
.el-loading-spinner i {
    color: #409EFF;
    font-size: 100px;
}
.flexw {
  flex-wrap: wrap;
}

.clearfix:after {
  content: "020";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  zoom: 1;
}

.novisibility {
  visibility: hidden;
  opacity: 0;
}

.flex-cen-xy {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flexc-cen-x {
  display: flex;
  align-items: center;
}

.flexc-cen-y {
  display: flex;
  justify-content: center;
}

.flex-y {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.flex-xy {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.mmm {
  height: 75% !important;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  padding-bottom: 20rpx !important;
}
.button view {
  font-size: 28rpx;
}
.textover{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.button1 view {
  font-size: 28rpx;
}
.flex-x {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.flex-spc-x {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-aro-x {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.flex-l-x {
  display: flex;
  flex-wrap: nowrap;
  justify-content: start;
}

.flex-r-x {
  display: flex;
  justify-content:flex-end;
  flex-wrap: nowrap;
  align-items: center;
}
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
  
    /* background-color:#ecf0f5 */
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue